module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"environments":["production"],"googleAnalytics":{"allowAdFeatures":false,"anonymize":true,"cookieName":"gatsby-gdpr-google-analytics","trackingId":"G-R9RFQH36JT"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-redux/gatsby-browser.js'),
      options: {"plugins":[],"cleanupOnClient":true,"pathToCreateStoreModule":"./src/store/createStore","serialize":{"ignoreFunction":true,"isJSON":false,"space":0,"unsafe":false},"windowKey":"__PRELOADED_STATE__"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"background_color":"#ffffff","display":"minimal-ui","icon":"src/images/icon.png","name":"BluoVerda e.V. Homepage","short_name":"BluoVerda e.V.","start_url":"/","theme_color":"#663399","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4da8f95c1cf99916995a8391a8da7241"},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
